
export const normalizeSubRoleValue = (value) => {
    if (!value) return '';

    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        if (!trimmedValue) return '';

        const upperCased = trimmedValue.toUpperCase();
        if (upperCased === 'NA' || upperCased === 'N/A') {
            return '';
        }

        return trimmedValue;
    }

    if (Array.isArray(value)) {
        for (const entry of value) {
            const normalized = normalizeSubRoleValue(entry);
            if (normalized) {
                return normalized;
            }
        }
        return '';
    }

    if (typeof value === 'object') {
        return (
            value?.name ||
            value?.label ||
            value?.permissions?.customRoleName ||
            value?.id ||
            ''
        );
    }

    return '';
};

/**
 * Extracts the sub-role name from a user object
 * @param {Object} user - The user object
 * @returns {string} The sub-role name or empty string
 */
export const getUserSubRoleName = (user) => {
    if (!user) return '';

    const candidates = [
        user.subRoleName,
        user.info?.subRoleName,
        user.provider?.subRoleName,
        user.profile?.subRoleName,
    ];

    for (const candidate of candidates) {
        const normalized = normalizeSubRoleValue(candidate);
        if (normalized) {
            return normalized;
        }
    }

    return '';
};

/**
 * Converts various date/time formats to ISO string
 * @param {string|Date|Object} value - The value to convert
 * @returns {string|null} ISO string representation or null
 */
export const toIsoString = (value) => {
    if (!value) return null;
    if (typeof value === 'string') return value;
    if (value instanceof Date) return value.toISOString();
    if (typeof value === 'object' && typeof value.seconds === 'number') {
        const milliseconds =
            value.seconds * 1000 + (value.nanoseconds || 0) / 1_000_000;
        return new Date(milliseconds).toISOString();
    }
    return null;
};

